import { go, some } from 'fxjs/es';

export const isEmptyCanvasTypeProduct = (image_ids) => {
  if (!image_ids?.length) return false;
  const seller_image_ids = [17376611];
  return go(
    seller_image_ids,
    some((seller_image_id) => image_ids.includes(seller_image_id)),
  );
};
